module.exports = __webpack_public_path__ + "static/img/headerImage.baefd97f.png";